import axios, { type AxiosResponse } from '@fs/zion-axios'
import { CAMPAIGN_SERVICE as SERVICE } from '../../serviceNames'

const BASE = `${SERVICE}/braze`

export const updateBrazeProfile = async (cisId: string, profile: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.put(`${BASE}/users/${cisId}`, profile)
